<template>
  <div class="overTimePage">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        :value="
          overInput.applicantName
            ? overInput.applicantName
            : overInput.applicantIdName
        "
        v-if="mode != 'add'"
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.realName"
        v-else
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="申请时间："
        :required="editType"
        readonly
        :value="mode == 'add' ? currentDateTime : overInput.createTime"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="overInput.locations"
        label="加班地点："
        :required="editType"
        :readonly="editType == true ? false : true"
        :placeholder="editType ? '请输入...  ' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <!-- 加班开始时间 -->
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="overInput.startTime"
        :required="editType"
        readonly
        label="开始时间："
        :placeholder="editType ? '请选择' : ''"
        @click="TimePicker(1)"
        :is-link="editType"
        class="ggInput"
      />
    </van-cell-group>
    <!-- 加班结束时间 -->
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="overInput.endTime"
        :required="editType"
        readonly
        label="结束时间："
        :placeholder="editType ? '请选择' : ''"
        @click="TimePicker(2)"
        class="ggInput"
        :is-link="editType"
      />
    </van-cell-group>
    <!-- 加班时间 -->
    <van-cell-group class="baseNone baseSalary moreLeaveText">
      <van-field
        v-model="overInput.hours"
        :required="editType"
        :readonly="!editType"
        label="加班时长（小时）"
        :placeholder="editType ? '请输入... ' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <!--是否节假日-->
    <van-cell-group class="baseNone baseSalary moreLeaveText">
      <van-field
        readonly
        label="是否节假日："
        :required="editType"
        v-model="overInput.isOR"
        @click="showHoliday"
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <!--加班原因-->
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="overInput.reason"
        rows="1"
        autosize
        :required="editType"
        :readonly="editType == true ? false : true"
        label="加班原因："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
      />
    </van-cell-group>
    <!--备注-->
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="overInput.remarks"
        rows="1"
        autosize
        label="备注："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="editType == true ? false : true"
      />
    </van-cell-group>
    <!-- 附件 -->
    <!-- 微信的附件 避免和原生交互 -->
    <wx-file-view
      v-if="is_weixn"
      :filesData="overInput"
      :editType="editType"
      class="fileview"
    ></wx-file-view>
    <!-- 原生附件 -->
    <file-view
      v-else
      :filesData="overInput"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view>

    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="mode !== 'add' && overInput.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="overInput"></audit-list>
    </div>
    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="mode !== 'add' && overInput.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="overInput"></flow-staff>
      <flow-list :workflowCode="overInput.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="overInput"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="overInput.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="overInput.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        overInput.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          overInput.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          overInput.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出层 -->
    <!-- 弹出层-时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
    <!-- 弹出层-是否节假日 -->
    <van-popup v-model="showisHoliday" position="bottom">
      <van-picker
        show-toolbar
        :columns="isHolidayPicker"
        value-key="name"
        @cancel="showisHoliday = false"
        @confirm="saveHoliday"
      />
    </van-popup>
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { dateTimeFormat, getCurTime, isEdit } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
export default {
  name: "overTimeApply",
  data() {
    return {
      mode: "add",
      editType: false, //能否编辑
      baseUrl: process.env.BASE_URL,
      refreshPagePicker: false,
      overInput: {
        id: "",
        applicantId: "", //申请人id
        applicantName: "", //申请人姓名
        locations: "", //加班地点
        startTime: "", //开始时间
        endTime: "", //结束时间
        isOR: "", ////是否节假日
        hours: "", //加班时长
        isHoliday: "", //是否节假日
        reason: "", //加班原因
        remarks: "", //备注
        verifyStatus: "hold", //详情的当前状态
        baseAnnexes: [], //附件
      },
      minHour: 10,
      maxHour: 20,
      showTimePicker: false, //时间控件
      currentDateTime: getCurTime(), //当前请假时间
      currentDate: new Date(), //当前时间
      minDate: new Date(2020, 1, 1),
      showisHoliday: false, //是否节假日弹框
      isHolidayPicker: [
        {
          name: "是",
          value: "true",
          bool: true,
        },
        {
          name: "否",
          value: "false",
          bool: false,
        },
      ], //是否节假日数据
      clientType: getDeviceType(),
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      sendType: "", //判断是否在抄送列表
      loadingText: "操作中...", //	btn加载状态提示文字
      is_weixn: is_wei(), //是否为微信
    };
  },
  components: {
    fileView,
    wxFileView,
    flowList,
    auditList,
    verifyMain,
    flowStaff,
  },
  mounted() {
    document.title = "加班申请";
    this.$nextTick(function () {
     
      this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
      this.commonId = this.$route.query.commonId; //申请Id
      this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
      this.editType = this.mode == "add" ? true : false;
      window.editPage = this.editPage; //编辑页面
      this.sendType = this.$route.query.sendType; // 1：在抄送列表
      this.setShowLoad(false); //加载状态，默认为true加载
      if (this.userinfo && this.userinfo.id) {
        this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
        this.overInput.applicantName =
          this.mode == "add" ? this.userinfo.realName : "";
        this.overInput.applicantId = this.mode == "add" ? this.userinfo.id : "";
      }
      this.mode !== "add" ? (this.commonId ? this.getDetails() : "") : "";
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    /*获取详情*/
    getDetails() {
      let _this = this;
      _this.$api.administration.administration.overTime
        .details(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.overInput = newApi.assign({}, _this.overInput, res.data);
            if (_this.overInput.remarks == null) {
              _this.$set(_this.overInput, "remarks", "无");
            }
            _this.overInput.isOR = res.data.isHoliday ? "是" : "否";
            if (_this.overInput.hours == null) {
              _this.overInput.hours = "";
            }
            if (
              (_this.overInput.verifyStatus == "hold" ||
                _this.overInput.verifyStatus == "deny") &&
              _this.mode == "edit" 
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    /*时间控件显示*/
    TimePicker(type) {
      if (this.editType) {
        this.checkIndex = type;
        this.showTimePicker = true;
      }
    },
    /*获取时间控件数据*/
    onTimeConfirm(data) {
      this.showTimePicker = false;
      if (this.checkIndex == "1") {
        this.overInput.startTime = dateTimeFormat(data);
      } else {
        this.overInput.endTime = dateTimeFormat(data);
      }
    },
    /*获取是否节假日*/
    showHoliday() {
      if (this.editType) {
        this.showisHoliday = true;
      }
    },
    saveHoliday(data) {
      this.showisHoliday = false;
      this.overInput.isHoliday = data.bool;
      this.overInput.isOR = data.name;
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.overInput.baseAnnexes = data;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      /*校验必填地段*/
      if (
        _this.overInput.applicantId &&
        _this.overInput.locations &&
        _this.overInput.startTime &&
        _this.overInput.endTime &&
        _this.overInput.hours &&
        (_this.overInput.isHoliday == false ||
          _this.overInput.isHoliday == true) &&
        _this.overInput.reason
      ) {
        _this.mode = msg;
        _this.saveAll();
      } else {
        _this.$toast("带星号为必填，不能为空");
      }
    },
    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.administration.administration.overTime
        .overSave(_this.mode, _this.overInput)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
          _this.btnLoading = false;
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;
      let msg = _this.overInput.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.administration.administration.overTime
            .operate(_this.overInput.verifyStatus, _this.overInput.id)
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.$toast("网络失败，请稍后重试");
              _this.btnLoading = false;
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
          this.overInput.applicantName =
            this.mode == "add" ? this.userinfo.realName : "";
          this.overInput.applicantId =
            this.mode == "add" ? this.userinfo.id : "";
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.overTimePage {
  width: 100%;

  background-color: #f6f6f6;
  padding-top: 12px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 5px;
    // overflow-y: initial;
  }
  .baseNone.moreLeaveText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin: 10px 0 45px 0;
  }
  //审批操作样式
}
</style>